import { render, staticRenderFns } from "./CustomerFax.vue?vue&type=template&id=362fd3ca"
import script from "./CustomerFax.vue?vue&type=script&lang=js"
export * from "./CustomerFax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports